export default "__VITE_ASSET__DJj63Vih__"